import { type Commands } from '../../../core/context/commands';
import { UUID } from '../../../core/context/uuid/entity';
import { ThreatVectorComments } from './repository';
import { ThreatVectorComment } from './entity';
import { type ThreatVectorCommentData } from './dto';

export class ThreatVectorCommentsCommands
    implements
        Commands<
            ThreatVectorComments,
            ThreatVectorComment,
            ThreatVectorCommentData
        >
{
    addAll(
        repo: ThreatVectorComments,
        data: ThreatVectorCommentData[],
    ): ThreatVectorComments {
        data.forEach((ThreatVectorCommentData) => {
            this.add(repo, ThreatVectorCommentData);
        });
        return repo;
    }

    add(
        repo: ThreatVectorComments,
        data: ThreatVectorCommentData,
    ): ThreatVectorComments {
        const threatVectorComment = new ThreatVectorComment({
            ...data,
            date: new Date(data.date),
        });
        repo.add(threatVectorComment);
        return repo;
    }

    update(
        repo: ThreatVectorComments,
        entity: ThreatVectorComment,
    ): ThreatVectorComment {
        repo.update(entity);
        return entity;
    }

    remove(repo: ThreatVectorComments, id: string): void {
        repo.remove(id);
    }

    create(
        repo: ThreatVectorComments,
        data: Omit<ThreatVectorCommentData, 'id'>,
    ): ThreatVectorComment {
        const uuid = new UUID();
        const threatVectorComment = new ThreatVectorComment({
            id: uuid.toString(),
            ...data,
            date: new Date(data.date),
        });
        repo.add(threatVectorComment);
        return threatVectorComment;
    }

    fromJSON(
        entity: ThreatVectorComment[],
        changeCallback: () => void,
    ): ThreatVectorComments {
        const newThreatVectorComments = new ThreatVectorComments(
            changeCallback,
        );
        entity.forEach((threatVectorComment) => {
            newThreatVectorComments.add(
                new ThreatVectorComment({
                    ...threatVectorComment,
                    date: new Date(threatVectorComment.date),
                }),
            );
        });
        return newThreatVectorComments;
    }
}
